/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import {
  changeFieldAnswer,
  selectFieldAnswer,
  sendRequest,
  selectRequestState
} from 'mt-react-common/modules/tasks/common/reducers/execAnswerConfirmForm';

import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';

// eslint-disable-next-line react/prefer-stateless-function
class TasksExecAnswerConfirmForm extends Component {
  componentDidUpdate(prevProp) {
    if (
      prevProp.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.closeAllTabs();
    }
  }
  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div className="tab-pane active">
        <div className="panel-footer pos-rel">
          {this.props.requestState.hasInProgress ? <OpacityPreLoader /> : null}
          <form>
            <div
              className={`form-group ${
                hasError(this.props.fieldAnswer.errors) ? 'has-error' : ''
              }`}
            >
              <label
                htmlFor={`execAnswerInput-${this.props.exec.id}`}
                className="control-label"
              >
                Вопрос: {this.props.exec.quizAsk}
              </label>
              <textarea
                id={`execAnswerInput-${this.props.exec.id}`}
                className="form-control"
                name="comment"
                placeholder={t('Введите ответ на вопрос...')}
                required=""
                rows="5"
                value={this.props.fieldAnswer.value}
                onChange={e => {
                  this.props.changeFieldAnswer(e.target.value);
                }}
              />
              {errorDesc(this.props.fieldAnswer.errors)}
            </div>
            <div className="btn-toolbar">
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => this.props.sendRequest()}
              >
                {t('Отправить ответ на вопрос')}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

TasksExecAnswerConfirmForm.propTypes = {
  // IN
  closeAllTabs: PropTypes.func.isRequired,
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired,
    quizAsk: PropTypes.string.isRequired
  }).isRequired,

  // CONNECT
  fieldAnswer: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  changeFieldAnswer: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.formReduceName),
  fieldAnswer: selectFieldAnswer(state, props.formReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldAnswer: value =>
    dispatch(changeFieldAnswer(props.formReduceName, value)),
  sendRequest: () => dispatch(sendRequest(props.formReduceName, props.exec.id))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecAnswerConfirmForm)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecAnswerConfirmForm/TasksExecAnswerConfirmForm.js